import CustomStepperComponent from "../../../../../components/CustomStepperComponent";
import EditTableIcon from "../../../../../assets/editTable.png";
import TrashIcon from "../../../../../assets/trashIcon.png";
import DetailsTable from "../../../../../components/DetailsTable";
import PdfDownload from "../../../../../components/PdfDownloadOrder";
import BorderLinearProgress from "../../../../../components/BorderLinearProgress";
import CustomButton from "../../../../../components/CustomButton";
import TableAddedPayments from "../../../../../components/TableAddPayments";
import DetailsOrder from "../../../../../components/DetailsOrder";
import fileIcon from "../../../../../assets/fileIcon.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useState, useContext, useEffect } from "react";
import { DollarContext } from "../../../../../contexts/DollarContext";
import api from "../../../../../services/api";
import { formatarValor } from "../../../../../components/OrderTable";
import { downloadFile, uploadFile } from "../../../../../axios/uploadFiles";
import SpinnerLoadingBlack from "../../../../../components/SpinnerLoadingBlack";
import SpinnerLoading from "../../../../../components/SpinnerLoading";
import ConfirmationModal from "../../../../../components/ConfirmationModal";
import useAttachmentsStore from "../../../../../store/attachmentsStore";
import { v4 as uuidv4 } from "uuid";

const DetalhesPedidos = () => {
  const { id, index } = useParams();

  const navigate = useNavigate();

  const { addAttachment, attachments, clearAttachments } =
    useAttachmentsStore();
  const dollarPriceToday = useContext(DollarContext);
  const [listPayments, setListPayments] = useState([]);
  const [order, setOrder] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [renderKey, setRenderKey] = useState(1);
  const [attachmentsData, setAttachmentsData] = useState([]);
  const [googleId1, setGoogleId1] = useState("");
  const [googleId2, setGoogleId2] = useState("");
  const [isLoadingPdf, setIsLoadingPdf] = useState(false);
  const [averageDollarPrice, setAverageDollarPrice] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isUploadFirstInputDone, setIsUploadFirstInputDone] = useState(false);
  const [isUploadSecondInputDone, setIsUploadSecondInputDone] = useState(false);
  const [isLoadingPdfUploadFirst, setIsLoadingPdfUploadFirst] = useState(false);
  const [isLoadingPdfUploadSecond, setIsLoadingPdfUploadSecond] =
    useState(false);

  const calculateAverageDollarPrice = (payments) => {
    let totalAmount = 0;
    let paymentsAmount = 0;
    for (const payment of payments) {
      if (payment.isPaid === false) continue;
      totalAmount +=
        Number(payment.exchange_rate) * Number(payment.payment_amount);
      paymentsAmount += Number(payment.payment_amount);
    }
    setAverageDollarPrice(totalAmount / paymentsAmount);
  };
  useEffect(() => {
    calculateAverageDollarPrice(listPayments);
  }, [setListPayments, listPayments]);

  const handleFileDeletion = async (googleId) => {
    try {
      const attachment = attachmentsData.find(
        (attach) => attach.google_id === googleId
      );

      if (!attachment) return;
      await api.delete(`/attachments/${attachment.id}`);

      window.location.reload();
    } catch (error) {
      console.log("Erro ao excluir o arquivo:", error);
    }
  };

  const handleFileUpload = async (e, inputNumber, description) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      if (file.type !== "application/pdf") {
        alert("Por favor, selecione um arquivo PDF.");
        return;
      }

      const MAX_FILE_SIZE = 5 * 1024 * 1024;
      if (file.size > MAX_FILE_SIZE) {
        alert("O arquivo excede o tamanho máximo permitido de 5MB.");
        return;
      }

      const tempReferenceId = uuidv4();

      if (inputNumber === 1) {
        setIsLoadingPdfUploadFirst(true);
      } else {
        setIsLoadingPdfUploadSecond(true);
      }

      try {
        const response = await uploadFile(file);
        const dbAttachmentsPost = {
          google_id: response.result.id,
          reference_id: tempReferenceId,
          reference_type: "TEMP",
          attachment_type: "ORDER_ATTACHMENT",
          attachment_description: description || response.result.name,
          privacy: "PUBLIC",
        };
        await api.post(`/attachments/create-attachment`, dbAttachmentsPost);

        addAttachment(dbAttachmentsPost.reference_id);

        const currentAttachments = useAttachmentsStore.getState().attachments;
        console.log("currentAttachments: ", currentAttachments);
        await api.put("/attachments/update-reference", {
          temp_reference_ids: currentAttachments,
          order_id: id,
          reference_type: "ORDER",
        });

        alert("PDF enviado com sucesso!");

        if (inputNumber === 1) {
          setIsUploadFirstInputDone(true);
        } else {
          setIsUploadSecondInputDone(true);
        }

        window.location.reload();
      } catch (error) {
        console.error("Erro ao enviar o arquivo:", error);
        alert(
          "Erro ao enviar o arquivo. Habilite o pop-up no seu navegador, ou sua conexão com a internet."
        );
      } finally {
        setIsLoadingPdfUploadFirst(false);
        setIsLoadingPdfUploadSecond(false);
      }
    }
  };

  useEffect(() => {
    clearAttachments();
    const fetchOrder = async () => {
      try {
        const response = await api.get(`/orders/${id}`);
        setOrder(response.data);
        const payments = response.data.order_Payments;
        setListPayments(payments);
      } catch (error) {
        console.error("Erro ao obter pedido: ", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchOrder();
  }, [id]);

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const response = await api.get(`/attachments/${id}`);

        console.log("response: ", response.data);
        setAttachmentsData(response.data);
      } catch (error) {
        console.error("Erro ao obter anexos: ", error);
      }
    };
    fetchOrder();
  }, [id]);

  useEffect(() => {
    if (!Array.isArray(attachmentsData) || !attachmentsData.length) {
      return;
    }

    const attachmentsFilter = attachmentsData.filter(
      (item) => item.reference_type === "ORDER"
    );
    for (const attachment of attachmentsFilter) {
      console.log("attachment: ", attachment);
      if (
        attachment.attachment_description === "first" &&
        attachment.hasOwnProperty("google_id")
      ) {
        setGoogleId1(attachment.google_id);
      }
      if (
        attachment.attachment_description === "second" &&
        attachment.hasOwnProperty("google_id")
      ) {
        setGoogleId2(attachment.google_id);
      }
    }
  }, [attachmentsData]);

  const somaValoresPagos = (payments) => {
    return payments.reduce((acc, payment) => {
      const valor = payment.isPaid ? parseFloat(payment.payment_amount) : 0;
      return acc + valor;
    }, 0);
  };

  if (isLoading) return <h1>Carregando...</h1>;

  if (Object.keys(order).length === 0) {
    navigate("/pedidos");
    navigate(0);
  }

  const totalPago = somaValoresPagos(listPayments);

  // const valorTotal = fixValorTotal(listPayments[0].valorTotal);

  const percentage = Math.ceil((totalPago / order.order_total) * 100);

  const handleNavigate = () => {
    navigate(`/pedidos/detalhes/${id}/novo-pagamento`);
  };

  const onHandleDownload = async (fileId, fileName) => {
    setIsLoadingPdf(true);
    try {
      const response = await downloadFile(fileId, fileName);
    } catch (error) {
      console.error("Erro ao baixar o arquivo:", error);
      alert(
        "Erro ao baixar o arquivo. Verifique sua conexão e tente novamente."
      );
    } finally {
      setIsLoadingPdf(false);
    }
  };

  const handleDeleteOrder = async (id) => {
    try {
      await api.delete(`/orders/delete-order/id/${id}`);
      setIsModalOpen(false);
      navigate("/pedidos", { replace: true });
      navigate(0);
    } catch (error) {
      setErrorMessage(
        error.status === 400
          ? error.response.data.message
          : "Não foi possível excluir o pedido"
      );
      console.error("Erro ao excluir pedido: ", error);
      return true;
    }
  };

  const navigateToEditOrder = async (orderId) => {
    try {
      // const response = await api.get(
      //   `/orders/check-has-order-load-items/${orderId}`
      // );
      // const hasOrderLoadItems = response.data.hasOrderLoadItems;

      // console.log("has order load items: ", hasOrderLoadItems);

      // if (hasOrderLoadItems) {
      //   alert("Não é possível editar um pedido que já tenha cargas.");
      //   return;
      // }

      navigate(`/pedidos/edit/${orderId}`);
    } catch (error) {
      console.error("erro ao navegar para o edit: ", error);
    }
  };

  if (!order) return;
  return (
    <>
      {isModalOpen && (
        <ConfirmationModal
          onClose={() => setIsModalOpen(false)}
          onConfirm={() => handleDeleteOrder(order.id)}
          errorMessage={errorMessage}
        />
      )}
      <div className="flex justify-between">
        <div className="flex items-center flex-col gap-4">
          <span className="rounded-md bg-extraLightGray uppercase w-[214px] py-1 text-center">
            {order.supplier_name}
          </span>
          <span className="rounded-md bg-extraLightGray uppercase w-[214px] py-1 text-center">
            {order.payment_method?.name}
          </span>
        </div>

        <div className="w-[70%]">
          <CustomStepperComponent order={order} key={renderKey} />
        </div>
        <div className="flex w-[100px] justify-between items-center">
          <button type="button" onClick={() => navigateToEditOrder(order.id)}>
            <img
              src={EditTableIcon}
              alt="ícone para editar tabela"
              className="w-[32px] h-[32px]"
            />
          </button>

          <button
            type="button"
            onClick={() => {
              setIsModalOpen(true);
              setErrorMessage("");
            }}
          >
            <img
              src={TrashIcon}
              alt="ícone para excluir"
              className="w-[27px] h-[32px]"
            />
          </button>
        </div>
      </div>
      <div>
        <DetailsTable order={order} />
      </div>
      <DetailsOrder
        order={order}
        title="Resumo do pedido"
        cbm={order.CBM}
        peso={order.weight}
        index={index}
      />
      <hr />
      <div className="flex p-4 mt-4 items-center">
        <img src={fileIcon} alt="ícone de arquivos" />
        <div className="flex justify-between items-center w-full">
          <h3 className="ml-6">Importacão de arquivos</h3>
        </div>
      </div>
      <div className=" w-full flex justify-between bg-superLightGray mt-6 shadow-xl mb-10">
        <div className="w-[463px] ">
          {isLoadingPdf ? (
            <SpinnerLoadingBlack>Baixando...</SpinnerLoadingBlack>
          ) : (
            <PdfDownload
              onDownload={() =>
                onHandleDownload(googleId1, "Proforma Invoice - Alvo.pdf")
              }
              isDownloadAvailable={order.isDownloadOneEnabled}
              identifier={"isDownloadOneEnabled"}
              isFileAvailable={googleId1}
              onUpload={(e) => handleFileUpload(e, 1, "first")}
              isUploadDone={isUploadFirstInputDone}
              onDelete={() => handleFileDeletion(googleId1)}
            />
          )}
        </div>
        <div className="w-[463px] ">
          {isLoadingPdf ? (
            <SpinnerLoadingBlack>Baixando...</SpinnerLoadingBlack>
          ) : (
            <PdfDownload
              onDownload={() =>
                onHandleDownload(googleId2, "Proforma Invoice - Alvo.pdf")
              }
              isDownloadAvailable={order.isDownloadTwoEnabled}
              identifier={"isDownloadTwoEnabled"}
              isFileAvailable={googleId2}
              onUpload={(e) => handleFileUpload(e, 2, "second")}
              isUploadDone={isUploadSecondInputDone}
              onDelete={() => handleFileDeletion(googleId2)}
            />
          )}
        </div>
      </div>
      <div className="flex justify-between  my-6 border-b-lightGray border-t-lightGray border-t border-y py-6 text-boldGray opacity-90">
        <div className="flex items-center">
          <p className="bold">Registro de pagamentos</p>
          <div className="w-[220px] ml-4">
            <CustomButton
              onClick={handleNavigate}
              setListPayments={setListPayments}
              className="bg-primary text-white font-bold text-sm"
            >
              Adicionar Pagamento
            </CustomButton>
          </div>
        </div>
        <div className="flex items-center">
          <p className="font-bold uppercase">Dólar médio</p>
          <span className="px-4 py-2">
            (R${" "}
            {typeof averageDollarPrice.toFixed(2) === "string" &&
            averageDollarPrice
              ? averageDollarPrice.toFixed(2)
              : dollarPriceToday?.replace("R$", "")}
            )
          </span>
        </div>
      </div>
      <TableAddedPayments
        payments={listPayments}
        setListPayments={setListPayments}
        setOrder={setOrder}
        setAverageDollarPrice={setAverageDollarPrice}
      />
      <div className="flex items-center mt-16 border-b-lightGray border-t-lightGray border-t py-6 justify-between">
        <div className="flex items-center">
          <span className="font-bold uppercase">A pagar</span>
          <span className="bg-softRed py-1 w-[185px] flex justify-center rounded-full ml-4 text-white font-bold">
            {formatarValor(order.amount_left, "USD")}
          </span>
        </div>
        <div className="w-[30%]">
          <span>Valor dos pagamentos</span>

          <div className="flex">
            <span>0%</span>
            <div className=" relative w-full max-w-md mx-auto p-4">
              <BorderLinearProgress
                variant="determinate"
                value={percentage}
                className="mt-2"
              />

              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 font-bold text-sm ">
                {percentage.toFixed(0)}%
              </div>
            </div>
            <span>100%</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetalhesPedidos;
